import Vue from "vue";
import Vuetify from "vuetify/lib";

Vue.use(Vuetify);

export default new Vuetify({
  breakpoint: {
    thresholds: {
      xs: 800
    }
  },
  theme: {
    options: {
      customProperties: true
    },
    themes: {
      light: {
        primary: "#1266AD",
        secondary: "#8C001A",
        accent: "#f2f2f2"
      }
    }
  }
});

// $colors: (
//   primary-dark:   #00549B,
//   primary:        #1266AD,
//   primary-light:  #A0C2DE,
//   secondary:      #8C001A,
//   secondary-light:#D199A3,
//   light:          #f4f4f4,
//   dark:           #222,
//   black:          #000,
//   lightgray:      #5A6566,
//   lightergray:    #f2f2f2,
//   white:          #ffffff,
// );
